import {
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import {
  fetchServiceDashboardStats,
  fetchServiceDashboardBrandStats,
} from "../../../API Service/apiService";
import HeaderNavigation from "../../../Componants/Common/header Navigation/HeaderNavigation";

import "./ServiceDashboard.css";

import DynamicTabs from "../../../components/DynamicTabs";

const cells = [
  "Brand",
  "Total Calls",
  "Open Calls",
  "Closed In Warranty (Repair)",
  "Closed Out Warranty (Repair)",
  "Closed In Warranty (Replacement)",
  "Closed Out Warranty (Replacement)",
  "Reappointment",
  "Pending for Part",
  "Payment Collected",
];

const ServiceDashboard = () => {
  const [visibleTables, setVisibleTables] = useState([]);
  const [value, setValue] = useState();
  const [stats, setStats] = useState(null);
  const [brandStats, setBrandStats] = useState([]);

  useEffect(() => {
    const getStats = async () => {
      try {
        const response = await fetchServiceDashboardStats();
        if (response.status === "success") {
          setStats(response.data);
        }
      } catch (error) {
        console.error("Error fetching dashboard stats:", error);
      }
    };

    const getBrandStats = async () => {
      try {
        const response = await fetchServiceDashboardBrandStats();
        if (response.status === "success") {
          setBrandStats(response.data);
        }
      } catch (error) {
        console.error("Error fetching brand stats:", error);
      }
    };

    getStats();
    getBrandStats();
  }, []);
  const Unallocated = "Unallocated";
  const Allocated = "Allocated";
  const Pendingforpart = "Pendingforpart";
  const Close = "Close";
  const toggleTable = (tableId) => {
    if (visibleTables.includes(tableId)) {
      setVisibleTables(visibleTables.filter((id) => id !== tableId));
    } else {
      setVisibleTables([tableId]);
    }
  };

  return (
    <Grid container>
      <HeaderNavigation value={"Service Center"} />
      {/* service-dashboard */}
      <DynamicTabs />
      <Grid
        container
        className="top-boxes-container"
        sx={{
          marginLeft: "5px",
          marginTop: "2px",
          marginRight: "5px",
          fontFamily: ["Roboto", "Helvetica", "Arial", "sans-serif"],
          borderRadius: "5px",
          padding: "10px",
          fontWeight: 600,
          width: "calc(100% - 10px)", // Adjust for margins
          boxSizing: "border-box",
        }}
      >
        {/* Calls Box */}
        <Grid item className="top-box">
          <Grid container justifyContent={"center"} sx={{ fontSize: 20, marginBottom: "10px" }}>
            Calls
          </Grid>
          <Grid container direction="column" alignItems="center" spacing={1}>
            <Grid item sx={{ fontSize: 16 }}>
              Total : {stats?.calls?.total || 0}
            </Grid>
            <Grid item sx={{ fontSize: 16 }}>
              Open : {stats?.calls?.open || 0}
            </Grid>
          </Grid>
        </Grid>

        {/* Closed (Repair) Box */}
        <Grid item className="top-box" sx={{ backgroundColor: "#F98500" }}>
          <Grid container justifyContent={"center"} sx={{ fontSize: 20, marginBottom: "10px" }}>
            Closed (Repair)
          </Grid>
          <Grid container direction="column" alignItems="center" spacing={1}>
            <Grid item sx={{ fontSize: 16 }}>
              In Warranty : {stats?.closedRepair?.inWarranty || 0}
            </Grid>
            <Grid item sx={{ fontSize: 16 }}>
              Out Warranty : {stats?.closedRepair?.outWarranty || 0}
            </Grid>
          </Grid>
        </Grid>

        {/* Close (Replacement) Box */}
        <Grid item className="top-box" sx={{ backgroundColor: "#F98500" }}>
          <Grid container justifyContent={"center"} sx={{ fontSize: 20, marginBottom: "10px" }}>
            Close (Replacement)
          </Grid>
          <Grid container direction="column" alignItems="center" spacing={1}>
            <Grid item sx={{ fontSize: 16 }}>
              In Warranty : {stats?.closedReplacement?.inWarranty || 0}
            </Grid>
            <Grid item sx={{ fontSize: 16 }}>
              Out Warranty : {stats?.closedReplacement?.outWarranty || 0}
            </Grid>
          </Grid>
        </Grid>

        {/* Open Calls Box */}
        <Grid item className="top-box" sx={{ backgroundColor: "#CF0808" }}>
          <Grid container justifyContent={"center"} sx={{ fontSize: 20, marginBottom: "10px" }}>
            Open Calls
          </Grid>
          <Grid container direction="column" alignItems="center" spacing={1}>
            <Grid item sx={{ fontSize: 16 }}>
              Reappointment : {stats?.openCalls?.reappointment || 0}
            </Grid>
            <Grid item sx={{ fontSize: 16 }}>
              Pending for Part : {stats?.openCalls?.pendingForPart || 0}
            </Grid>
          </Grid>
        </Grid>

        {/* Total Payment Collected Box */}
        <Grid item className="top-box" sx={{ backgroundColor: "#23AF00" }}>
          <Grid container justifyContent={"center"} sx={{ fontSize: 19, marginBottom: "10px" }}>
            Total Payment
          </Grid>
          <Grid container justifyContent={"center"} alignItems="center" sx={{ height: "100%" }}>
            <Grid item sx={{ fontSize: 25 }}>
              {stats?.totalPayment || 0}
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Grid
        container
        sx={{
          background: "#EFF3FE",
          marginLeft: "10px",
          marginTop: "4px",
          marginRight: "10px",
          fontFamily: ["Roboto", "Helvetica", "Arial", "sans-serif"],
          width: "100%",
          borderRadius: "5px",
          padding: "10px",
          fontWeight: 600,
        }}
      >
        <h4>Brand Wise</h4>
        <Grid container>
          <TableContainer component={Paper}>
            <Table
              sx={{ minWidth: 650 }}
              size="small"
              aria-label="simple table"
            >
              <TableHead>
                <TableRow>
                  {cells.map((cell, index) => (
                    <TableCell
                      key={index}
                      sx={{ color: "white", textAlign: "center", whiteSpace: "nowrap" }}
                    >
                      {cell}
                    </TableCell> // Adding a key prop
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {brandStats.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell align="center">{row.brandName}</TableCell>
                    <TableCell align="center">{row.totalCalls}</TableCell>
                    <TableCell align="center">{row.openCalls}</TableCell>
                    <TableCell align="center">{row.repairInWarranty}</TableCell>
                    <TableCell align="center">{row.repairOutWarranty}</TableCell>
                    <TableCell align="center">{row.replacementInWarranty}</TableCell>
                    <TableCell align="center">{row.replacementOutWarranty}</TableCell>
                    <TableCell align="center">{row.reappointment}</TableCell>
                    <TableCell align="center">{row.pendingForPart}</TableCell>
                    <TableCell align="center">{row.paymentCollected}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ServiceDashboard;
